import { useIsModalPacingEnabled } from '@/app-shell/flags/growth-flags';
import { isModalPacingEnabledAtom } from '@/atoms/modalPacing';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

/** Mirrors PostHog kill switch into `isModalPacingEnabledAtom`. Renders nothing. */
export const ModalPacingSync = () => {
  const isEnabled = useIsModalPacingEnabled();
  const setEnabled = useSetAtom(isModalPacingEnabledAtom);

  useEffect(() => {
    setEnabled(isEnabled);
  }, [isEnabled, setEnabled]);

  return null;
};
